<style lang="scss" scoped>
@use '~@/styles/base/variables';
$padding-for-mobile-bottom-panel: 50px;
.aside {
  background-color: #404364;
  border-radius: 5px;
}

.header {
  position: sticky;
  top: 0px;
  padding: 2rem 1.6rem;
  text-align: left;
  background-color: #404364;
  z-index: 2;
  border-bottom: 1px solid #2a2f44;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.hook-list {
  $margin-x: 1.6rem;
  $margin-y: 1.4rem;

  &__item {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 1rem;

    .name {
      min-height: 52px;
      font-size: 1.6rem;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: $margin-y;
      padding-bottom: $margin-y;
      padding-left: $margin-x;
      cursor: pointer;
    }

    .switch {
      margin-right: $margin-x;
    }

    &:nth-child(even) {
      background-color: #3a3d5a;
    }

    &:first-child {
      margin-top: 6px;
    }

    &_hover {
      background-color: #4b4e77 !important;
    }

    &_choosen {
      background-image: linear-gradient(to bottom left,var(--color-accent-dark),#633cfc);
      cursor: default;
    }
  }
}

@media screen and (max-width: variables.$standart) {
  .header {
    padding: 1rem 1rem;
  }
}

@media screen and (max-width: variables.$small) {
  .header {
    .add-hook {
      width: 100%;
    }
  }

  .aside {
    display: none;
    padding-bottom: $padding-for-mobile-bottom-panel;

    &_mobile {
      display: block;

      .header {
        box-shadow: none;
      }
    }
  }
}
</style>

<template>
  <aside
    class="aside"
    :class="{
      aside_mobile:
        $store.state.hooks.showMobileHookList ||
        !$store.state.hooks.hookList.length,
    }"
  >
    <header class="header">
      <button
        class="ghost-btn ghost-btn_success add-hook"
        @click="addNewHook()"
      >
        <Icon
          type="md-add"
        />
      </button>
    </header>
    <Modal
      v-model="showSaveModal"
      @on-ok="saveHookChanges()"
      @on-cancel="undoHookChanges()"
      :okText="'СОХРАНИТЬ'"
      :cancelText="'ОТМЕНИТЬ'"
    >{{ $text.tr('Сохранить изменения?')}}
    </Modal>
    <div class="hook-list">
      <div
        v-for="(hook, index) in $store.state.hooks.hookList"
        :key="index"
        class="hook-list__item"
        :class="{
          'hook-list__item_choosen':
            index === $store.state.hooks.currentHookIndex,
          'hook-list__item_hover':
            index === hoveredHookNameIndex
        }"
      >
        <span
          class="name"
          @click="chooseHook(index)"
          @mouseover="hoveredHookNameIndex = index"
          @mouseleave="hoveredHookNameIndex = null"
        >{{
          hook.Params.Name
        }}</span>
        <i-switch
          v-model="hook.Params.Active"
          class="switch"
          @on-change="editHookActive(hook.Params, index)"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import hooks from '@/services/hooks'

export default {
  data () {
    return {
      showSaveModal: false,
      cashedHookIndex: 0,
      hoveredHookNameIndex: null
    }
  },
  methods: {
    chooseHook (index) {
      if (index === this.cashedHookIndex) {
        return
      }

      this.cashedHookIndex = index

      if (this.$store.state.hooks.isEditingHook) {
        this.showSaveModal = true
      } else {
        this.changeHookIndex(index)
      }
    },
    changeHookIndex (index) {
      this.$store.state.hooks.currentHookIndex = index
      this.$store.state.hooks.showMobileHookList = false
    },
    addNewHook () {
      hooks.editHook()
    },
    undoHookChanges () {
      this.$store.state.hooks.hookList.splice(
        this.$store.state.hooks.currentHookIndex,
        1,
        this.$store.state.hooks.cashedCurrentHook
      )

      this.changeHookIndex(this.cashedHookIndex)
    },
    editHookActive (hookParams, index) {
      hooks.editHook(hookParams, index)
    },
    saveHookChanges () {
      hooks.editHook(this.$store.getters.currentHook.Params).then(() => {
        this.changeHookIndex(this.cashedHookIndex)
      })
    }
  }
}
</script>
